import apiClient from "@shared/services/apiClient";

const WARMUP_RETRY_MS = 5 * 60 * 1000;
const warmupAttempts = new Map<string, number>();

export function scheduleStudyVideoPlaybackWarmup(studyIds: string[]): void {
  const now = Date.now();
  const uniqueStudyIds = [...new Set(studyIds.filter(Boolean))];

  for (const studyId of uniqueStudyIds) {
    const lastAttempt = warmupAttempts.get(studyId) ?? 0;
    if (now - lastAttempt < WARMUP_RETRY_MS) {
      continue;
    }

    warmupAttempts.set(studyId, now);
    void apiClient
      .post(`/video-eeg/study/${studyId}/prepare`)
      .catch(() => {
        warmupAttempts.delete(studyId);
      });
  }
}

export function resetStudyVideoPlaybackWarmupForTests(): void {
  warmupAttempts.clear();
}
